import { NavItem } from '../interfaces/navitem.interface';

export const NAV_ITEMS: NavItem[] = [
  { label: '행사안내', path: '/event' },
  { label: '갤러리', path: '/gallery' },
  { label: '고객센터', path: '/customer' },
  { label: '방송 홍보 제휴 문의', path: '/inquiry' },
];
